// Core Module
// ONLY provide services from this module

import { NgModule } from '@angular/core';
import { environment } from '../../environments/environment';

// Angular Fire - Modern API (non-compat) - MUST be in CoreModule for proper injection context
import { FirebaseApp, provideFirebaseApp, initializeApp, getApp } from '@angular/fire/app';
import { provideAppCheck, initializeAppCheck, ReCaptchaEnterpriseProvider, ReCaptchaV3Provider } from '@angular/fire/app-check';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { provideStorage, getStorage } from '@angular/fire/storage';
import { providePerformance, getPerformance } from '@angular/fire/performance';
import { provideFunctions, getFunctions } from '@angular/fire/functions';

// Custom services
import { QuestionService } from './question.service';
import { UserService } from './user.service';
import { QuestionControlService } from './question-control.service';
import { SessionService } from './session.service';
import { UnivPrefsService } from './univ-prefs.service';
import { ResultService } from './result.service';
import { EmailService } from './email.service';
import { ProgressGuard } from './progress.guard';
import { WelcomeService } from './welcome.service';
import { EclService } from './ecl.service';
import { JourneyService } from './journey.service';
import { DevFormFillService } from './dev-form-fill.service';

@NgModule({
  imports: [],
  providers: [
    // Angular Fire providers (modern API) - MUST be in CoreModule for proper injection context
    // This ensures they're available when CoreModule services are instantiated
    provideFirebaseApp(() => initializeApp(environment.firebaseEnv)),
    provideAppCheck(() => {
      return initializeAppCheck(getApp(), {
        provider: new ReCaptchaV3Provider(environment.appCheck.siteKey),
        isTokenAutoRefreshEnabled: true
      });
    }),
    provideFirestore(() => getFirestore()),
    provideAuth(() => getAuth()),
    provideStorage(() => getStorage()),
    providePerformance(() => getPerformance()),
    provideFunctions(() => getFunctions()),
    // Custom services
    QuestionService,
    QuestionControlService,
    UserService,
    SessionService,
    UnivPrefsService,
    ResultService,
    EmailService,
    ProgressGuard,
    WelcomeService,
    EclService,
    JourneyService,
    DevFormFillService,
  ]
})
export class CoreModule { }
